import TemplateView from '../../../../../../TemplateView'
import ImportHolidaysListLine from './ImportHolidaysListLine'

export default class ImportHolidaysList extends TemplateView {
    constructor() {
        super()

        this.state = {
            holidays: [],
        }

        this.onStatePropertyChanged('holidays', () => {
            this.renderList()
        })
    }

    templateHtml() {
        return '<div class="importHolidaysList"/>'
    }

    renderList() {
        this.getEl().empty()
        this.state.holidays.forEach((holiday) => {
            new ImportHolidaysListLine({
                date: Date.parseJSONDate(holiday.date),
                name: holiday.name,
            }).init(this.getEl())
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/components/ImportHolidaysList.js